// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","footer__social":"Footer_footer__social__n0D1R"};